// extracted by mini-css-extract-plugin
export var container = "_1w-0";
export var disabled = "_1w-4";
export var fullWidth = "_1w-3";
export var lined = "_1w-1";
export var selected = "_1w-5";
export var tab = "_1w-2";